package org.example.zone360.pages.coachDetails.sessionAllDetails.sessionEmphasis

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import kotlinx.browser.document
import kotlinx.browser.window
import org.example.zone360.models.GetSessionKeyword
import org.example.zone360.models.GetSessionKeywordsData
import org.example.zone360.models.KeywordExtraction
import org.example.zone360.theme.SitePalette
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Canvas
import org.w3c.dom.HTMLCanvasElement

@Composable
fun SpeakingDonutChart(
    keywords: List<GetSessionKeywordsData>,
    sitePalette: SitePalette
) {
    val (xValues, yValues, barColors) = remember(keywords) {
        val categoryCounts = keywords
            .groupBy { it.keywordCategory.trim().lowercase() }
            .mapValues { (_, values) -> values.sumOf { it.usageCount } }
        val x = listOf("Technical", "Fitness", "Tactical", "Mental", "Goalkeeper", "Custom")

        val y = listOf(
            categoryCounts["technical"] ?: 0,
            categoryCounts["fitness"] ?: 0,
            categoryCounts["tactical"] ?: 0,
            categoryCounts["mental"] ?: 0,
            categoryCounts["goalkeeper"] ?: 0,
            categoryCounts.filterKeys { it !in listOf("technical", "fitness", "tactical", "mental", "goalkeeper") }.values.sum()
        )

        val colors = listOf(
            sitePalette.technicalCategoryBorder.hex,
            sitePalette.fitnessCategoryBorder.hex,
            sitePalette.tacticalCategoryBorder.hex,
            sitePalette.mentalCategoryBorder.hex,
            sitePalette.goalKeeperCategoryBorder.hex,
            "#FB6F2A" // custom/other category
        )

        Triple(x, y, colors)
    }

    val chartSize =  if (window.screen.width in 1300 .. 1400) 105.px else if (window.screen.width in 1401 .. 1570) 120.px else 150.px

    Canvas(
        Modifier
            .width(chartSize)
            .height(chartSize)
            .id("speakingDonutChart")
            .toAttrs()
    ) {}

    LaunchedEffect(xValues, yValues) {
        val canvas = document.getElementById("speakingDonutChart") as? HTMLCanvasElement
        if (canvas != null) {
            val adjustedYValues = if (yValues.all { it == 0 }) yValues.map { 1 } else yValues

            val script = """
            (function() {
                const existingChart = Chart.getChart("speakingDonutChart");
                if (existingChart) {
                    existingChart.destroy();
                }

                const xValues = ${xValues.map { "\"$it\"" }};
                const yValues = ${adjustedYValues};
                const barColors = ${barColors.map { "\"$it\"" }};
                const total = ${yValues.sum()};

                new Chart("speakingDonutChart", {
                    type: "doughnut",
                    data: {
                        labels: xValues,
                        datasets: [{
                            backgroundColor: barColors,
                            data: yValues
                        }]
                    },
                    options: {
                        plugins: {
                            legend: { display: false },
                            title: { display: false }
                        },
                        cutout: '75%',
                        responsive: false,
                        maintainAspectRatio: false,
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    const actualValue = ${yValues}[tooltipItem.index];
                                    const percentage = ((actualValue / (total || 1)) * 100).toFixed(2);
                                    const label = data.labels[tooltipItem.index];
                                    return label + ": " + percentage + "%";
                                }
                            }
                        }
                    }
                });
            })();
        """.trimIndent()

            val scriptElement = document.createElement("script")
            scriptElement.textContent = script
            document.body?.appendChild(scriptElement)
        } else {
            console.error("Canvas element not found")
        }
    }

}


